import { render, staticRenderFns } from "./AvatarNotificationBubble.vue?vue&type=template&id=11940aa2&"
import script from "./AvatarNotificationBubble.vue?vue&type=script&lang=js&"
export * from "./AvatarNotificationBubble.vue?vue&type=script&lang=js&"
import style0 from "./AvatarNotificationBubble.vue?vue&type=style&index=0&id=11940aa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports